// extracted by mini-css-extract-plugin
export default {"root":"input_root__pOM5i","sm":"input_sm__4LTtF","md":"input_md__mSBnr"};